import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const CalendarView = lazy(async () => {
  const m = await import("@/features/journal/components/calendar-view");
  return { default: m.CalendarView };
});

function CalendarPage() {
  return (
    <Suspense fallback={null}>
      <CalendarView />
    </Suspense>
  );
}

/** Calendar state in the URL: navigated month/year (`?ym=YYYY-MM`) and
 * drill-down mode (`?view=months|years`). The `days` mode is the default and is
 * omitted for clean URLs. Thus "March 2024 calendar" is copyable/reloadable. */
export interface CalendarSearch {
  ym?: string;
  view?: "months" | "years";
}

const YM_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/u;

export const calendarRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/calendar",
  validateSearch: (raw: Record<string, unknown>): CalendarSearch => ({
    ym: typeof raw.ym === "string" && YM_PATTERN.test(raw.ym) ? raw.ym : undefined,
    view: raw.view === "months" || raw.view === "years" ? raw.view : undefined,
  }),
  component: CalendarPage,
});
